/**
 Author - Muhamed Afsal
 Git - https://bitbucket.org/mohdafsal/
 **/

import SubscribeContainer from "./Subscribe.container";

export default SubscribeContainer;
